import { accountsSelector } from '@/data/account/selectors/childAccounts';
import { getAuthAccount } from '@/shared/auth/selectors';

import { createSelector } from '@reduxjs/toolkit';

export const getMasterAccount = createSelector([accountsSelector, getAuthAccount], (accounts, currentAccount) =>
  currentAccount ? accounts.items.get(currentAccount.master_id, null) : null,
);
